
'use strict';

import objectAssign from 'object-assign';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';


/***
    // create an instance
    let myGallery = imageGallery(document.querySelector('[data-image-gallery]'));

    // initialise the gallery
    myGallery.init();
*/


// find nearest parent element
function closest(el, fn) {
    return el && ( fn(el) ? el : closest(el.parentNode, fn) );
}


function parseThumbnailElements(galleryElem) {
    const targetAttribute = 'data-gallery-thumbnail-container';
    let mediaElems = galleryElem.querySelectorAll(`[${targetAttribute}]`);

    // only get visible media elems
    let visibleItems = [].filter.call(mediaElems, (elem) => {
        return elem.offsetHeight > 0 && elem.offsetWidth > 0;
    });

    let items = visibleItems.map((elem) => {
        let item = {};
        let thumbnailElem = elem.querySelector('[data-gallery-thumbnail]');

        let sketchfabEmbedURL = elem.getAttribute('data-sketchfab-embed');

        if (sketchfabEmbedURL && sketchfabEmbedURL.length > 0) {
            item.html = `
                <div class="sketchfab-embed-container">
                    <div class="sketchfab-embed flexible-iframe">
                        <iframe width="640" height="360" src="${sketchfabEmbedURL}" frameborder="0" allowfullscreen mozallowfullscreen="true" webkitallowfullscreen="true" onmousewheel=""></iframe>
                    </div>
                </div>
            `;
        } else {
            item.w = parseInt(elem.getAttribute('data-target-img-width'), 10 );
            item.h = parseInt(elem.getAttribute('data-target-img-height'), 10 );
            item.msrc = thumbnailElem.currentSrc || thumbnailElem.src;
            item.src = elem.href;
        }

        item.el = elem;

        return item;
    });

    return items;
}


function openPhotoSwipe(index, galleryElement, disableAnimation, fromURL) {
    let pswpElement = document.querySelector('.pswp');
    let gallery;
    let options;
    let items;
    
    items = parseThumbnailElements(galleryElement);

    // console.log(items);

    options = {
        // define gallery index (for URL)
        galleryUID: galleryElement.getAttribute('data-pswp-uid'),
        closeOnScroll: false,
        shareEl: false,
        fullscreenEl: false,
        clickToCloseNonZoomable: false,
        index: index,
        getThumbBoundsFn: function(index) {
            // See Options -> getThumbBoundsFn section of documentation for more info
            var thumbnail = items[index].el.getElementsByTagName('img')[0];
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var rect;

            if (thumbnail) {
                rect = thumbnail.getBoundingClientRect();
            } else {
                rect = {
                    left: 0,
                    top: 0,
                    width: 200
                }
            }

            return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
            };
        }
    };

    // exit if index not found
    if( isNaN(options.index) ) {
        return;
    }

    if (disableAnimation) {
        options.showAnimationDuration = 0;
    }

    // Pass data to PhotoSwipe and initialize it
    gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();

    return gallery;
};


function onGalleryElemInputDown(event) {
    event.preventDefault();

    let e = event || window.event;
    let eTarget = e.target || e.srcElement;

    // find root element of slide
    let clickedListItem;

    // target attribute of the thumbnails
    const targetAttribute = 'data-gallery-thumbnail-container';

    if ( eTarget.hasAttribute && eTarget.hasAttribute(targetAttribute) ) {
        clickedListItem = eTarget;
    } else if ( eTarget.parentNode.hasAttribute && eTarget.parentNode.hasAttribute(targetAttribute) ) {
        clickedListItem = eTarget.parentNode;
    } else {
        clickedListItem = closest(eTarget, function(el) {
            return ( el.hasAttribute && el.hasAttribute(targetAttribute) );
        });
    }

    if (!clickedListItem) {
        return;
    }

    // find index of clicked item by looping through all child nodes
    let clickedGalleryElem = clickedListItem.parentNode;
    let childNodes = clickedGalleryElem.querySelectorAll(`[${targetAttribute}]`);
    let targetIndex;

    [].forEach.call(childNodes, (elem, index) => {
        if (elem === clickedListItem) {
            targetIndex = index;
        }
    });

    // open PhotoSwipe if valid index found
    if (targetIndex >= 0) {
        // console.log('open photoswipe', targetIndex, clickedGalleryElem);
        openPhotoSwipe( targetIndex, clickedGalleryElem );
    }

    return false;
}


function setEvents(elem, handlers) {
    elem.addEventListener('click', handlers.onInputDown);
}


/***
 * factory method that creates the instance
 *
 */
function imageGallery(rootElem) {
    if (!rootElem) {
        console.warn('No element provided for imageGallery!')
        return;
    }

    return objectAssign({}, {
        elem: rootElem,

        init: function() {
            setEvents(rootElem, {
                onInputDown: onGalleryElemInputDown
            });
        }
    });
}


export default imageGallery;







/** WEBPACK FOOTER **
 ** ./src/scripts/client/widgets/imageGallery.js
 **/